import { render, staticRenderFns } from "./FinanceSalesReportHistoricalPage.vue?vue&type=template&id=a3ba91a6&scoped=true"
import script from "./FinanceSalesReportHistoricalPage.vue?vue&type=script&lang=js"
export * from "./FinanceSalesReportHistoricalPage.vue?vue&type=script&lang=js"
import style0 from "./FinanceSalesReportHistoricalPage.vue?vue&type=style&index=0&id=a3ba91a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ba91a6",
  null
  
)

export default component.exports